/**
 * @module components\ghTable\vuetifyTable
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch, Inject } from "vue-property-decorator";
import VuetifyRow from "./vuetifyRow/vuetifyRow";

@Component({
  components: { VuetifyRow }
})
export default class VuetifyTable extends Vue {
  @Prop()
  props!: IGHTableProps;

  @Inject()
  syncProps: IGhTableSyncProps;

  private maxHeight: any = "400px";

  public get InnerProps() {
    let pros = {
      headers: this.Headers,
      items: this.props.items,
      totalItems: this.props.totalItems,

      itemKey: "Id"
    };
    return pros;
  }

  public get InnerSyncProps() {
    let p = {
      pagination: this.syncProps.pagination,
      value: this.syncProps.selectedItems
    };
    return p;
  }
  public get Headers() {
    if (this.props.headers) {
      let hs = this.props.headers as ITableHeader[];
      return hs.filter(h => !h.hide);
    }
  }

  public get TotalPages() {
    if (this.props.totalItems && this.syncProps.pagination) {
      return Math.ceil(
        this.props.totalItems /
          (this.syncProps.pagination.rowsPerPage as number)
      );
    }
  }

  // private innerProps: IVuetifyDataTableProps = {};

  mounted() {}
  activated() {
    this.$nextTick(() => {
      this.resize();
    });
  }

  private getTemplateName(header: IndexObject) {
    return "table-cell-" + header.value;
  }

  private get HideActions() {
    return this.props.paginateServerSide;
  }

  updated() {
    this.resize();
  }

  // @Watch("props", { deep: true })
  private resize() {
    let table = this.$refs.table as Vue;
    let top = this.$el.getBoundingClientRect().top;
    let h = window.innerHeight;
    let height = h - top - 40;
    this.maxHeight = height + "px";
  }
}
